(() => {
  if (customElements.get('zenova-problem-tabs')) return;

  class ZenovaProblemTabs extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.tabs = Array.from(this.querySelectorAll('[data-zp-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-zp-panel]'));
      if (!this.tabs.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab), options);
        tab.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          const enabled = this.tabs.filter((item) => !item.disabled);
          const current = enabled.indexOf(tab);
          const index = { ArrowRight: (current + 1) % enabled.length, ArrowLeft: (current + enabled.length - 1) % enabled.length, Home: 0, End: enabled.length - 1 }[event.key];
          if (index === undefined) return;
          event.preventDefault();
          this.select(enabled[index], true);
        }, options);
      });
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-zp-panel]');
        if (!panel) return;
        const tab = this.tabs.find((item) => item.dataset.zpTab === panel.dataset.zpPanel);
        if (tab) this.select(tab);
      }, options);
      const selected = this.tabs.find((tab) => !tab.disabled && tab.getAttribute('aria-selected') === 'true') || this.tabs.find((tab) => !tab.disabled);
      if (selected) this.select(selected);
    }

    select(tab, focus = false) {
      if (!tab || tab.disabled) return;
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.zpPanel !== tab.dataset.zpTab;
      });
      if (focus) tab.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('zenova-problem-tabs', ZenovaProblemTabs);
})();
